import React, { forwardRef, memo } from 'react'

const LeroyIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="47.6"
      height="47.6"
      viewBox="0 0 68 68"
      fill="none"
      {...props}>
      <circle cx="34" cy="34" r="34" fill="#78BE20" />
      <path
        d="M49 40H18L33.5 23L49 40Z"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  )
)

LeroyIcon.displayName = 'LeroyIcon'

export default memo(LeroyIcon)
